import { useEffect, useState } from "react";

const useProductGallery = (images = []) => {
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [imageZoom, setImageZoom] = useState(false);
  const [zoomPosition, setZoomPosition] = useState({ x: 0, y: 0 });

  const handleImageMouseMove = (e) => {
    if (!imageZoom) return;
    const rect = e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    setZoomPosition({ x, y });
  };

  const handlePreviousImage = (e) => {
    e.stopPropagation();
    setSelectedImageIndex((prev) =>
      prev === 0 ? images.length - 1 : prev - 1,
    );
  };

  const handleNextImage = (e) => {
    e.stopPropagation();
    setSelectedImageIndex((prev) =>
      prev === images.length - 1 ? 0 : prev + 1,
    );
  };

  useEffect(() => {
    if (!lightboxOpen || !images?.length) return;

    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        setLightboxOpen(false);
      } else if (e.key === "ArrowRight") {
        setSelectedImageIndex((prev) =>
          prev === images.length - 1 ? 0 : prev + 1,
        );
      } else if (e.key === "ArrowLeft") {
        setSelectedImageIndex((prev) =>
          prev === 0 ? images.length - 1 : prev - 1,
        );
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [lightboxOpen, images]);

  return {
    selectedImageIndex,
    setSelectedImageIndex,
    lightboxOpen,
    setLightboxOpen,
    imageZoom,
    setImageZoom,
    zoomPosition,
    handleImageMouseMove,
    handlePreviousImage,
    handleNextImage,
  };
};

export default useProductGallery;
